export default __webpack_public_path__ + "static/media/Mask_Group_1.5c54bda2.png";